



































































































































import { Component, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputCode } from '@/components/molecules/InputCode'
import { InputCodeName } from '@/components/molecules/InputCodeName'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import { MarcTagInput } from '@/components/modals/ModalBibliographyTagDataEdit/ModalBibliographyTagDataEdit.vue'
import { InputAuthor } from '@/components/molecules/InputAuthor'
import InputPublisher from '@/components/molecules/InputPublisher/InputPublisher.vue'
import InputSubject from '@/components/molecules/InputSubject/InputSubject.vue'
import InputSeries from '@/components/molecules/InputSeries/InputSeries.vue'
import InputCompleteWorks from '@/components/molecules/InputCompleteWorks/InputCompleteWorks.vue'
import { AuthorityItem, MaskPattern } from '@/types'

@Component({
  components: {
    InputCompleteWorks,
    InputSeries,
    InputSubject,
    InputPublisher,
    InputCode,
    InputCodeName,
    InputDatePicker,
    InputAuthor
  }
})
export default class BibliographyTagInput extends ComponentVue {
  @PropSync('input', {
    type: Object,
    required: true
  })
  internalInput!: MarcTagInput

  resetErrorMessage() {
    this.internalInput.errorMessage = ''
  }

  get maskNumber() {
    return (maxLength: number) => {
      return '#'.repeat(maxLength)
    }
  }

  get maskAlphaNumber() {
    return (maxLength: number) => {
      return 'X'.repeat(maxLength)
    }
  }

  get maskAlphaMarkNumber() {
    return () => {
      return MaskPattern.AlphaMarkNumberOnly
    }
  }

  onInputAuthorityText(text: string) {
    this.$emit('input:authority-text', text)
  }

  onInputAuthority(item: AuthorityItem) {
    this.$emit('input:authority', item)
  }
}
